module.exports = __webpack_public_path__ + "static/media/logod.423c312c.png";